import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import * as styles from './ReliableBlock.css';
import { Link } from '../Link';
import { ReliableZhkIcon } from '../Reliability/ReliabilityIcons';

interface IReliableBlockProps {
  text: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function ReliableBlock({ text, onClick }: IReliableBlockProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <ReliableZhkIcon />
      </div>
      <div>
        <ArticleParagraph2>{text}</ArticleParagraph2>
        <Link url={'#reliable'} onClick={onClick}>
          Узнать больше
        </Link>
      </div>
    </div>
  );
}
